export const PWA_UPDATE_STATUS = Object.freeze({
  CURRENT: "current",
  AVAILABLE: "available",
  APPLYING: "applying",
  RELOAD_REQUIRED: "reload-required",
});
